import CryptoJS from 'crypto-js';
import stringify from 'fast-json-stable-stringify';

export default function Checksum(obj) {
  return CryptoJS.SHA1(stringify(obj)).toString(CryptoJS.enc.Hex);
}